import { getAppConfig } from '@services/config';
import { apiHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

import {
    RecommerceCriteriaType,
    RecommerceProductsType,
    RecommerceQuoteType,
    TradeInAutocompleteType,
    TradeInCriteriaResponsesType,
    TradeInCriteriaType,
    TradeInQuoteType,
} from '@app-types/trade-in';

const appConfig = getAppConfig();

export const getPartnerProducts = async (
    productName: string,
    abortController: AbortController,
): Promise<TradeInAutocompleteType[]> => {
    if (productName.length < 3) {
        return [];
    }

    return apiHttpService
        .get<RecommerceProductsType>(
            `${appConfig.b2r.url}/produits-partenaires?${new URLSearchParams({ libelle: productName })}`,
            undefined,
            {
                controller: abortController,
                ttl: parseInt(getAppConfig().cache.ttl.productDetail),
                tags: [CACHE_TAGS.PRODUCT_DETAIL],
            },
        )
        .then((res) => {
            return res.items.map((item) => {
                return {
                    label: item.nom,
                    brand: item.marque,
                    data: {
                        id: item.id,
                    },
                };
            });
        })
        .catch(() => []);
};

export const getPartnerProductTradeInQuestions = async (productId: string): Promise<TradeInCriteriaType> => {
    return apiHttpService
        .get<RecommerceCriteriaType>(`${appConfig.b2r.url}/produits-partenaires/${productId}`, undefined, {
            ttl: parseInt(getAppConfig().cache.ttl.productDetail),
            tags: [CACHE_TAGS.PRODUCT_DETAIL],
        })
        .then((res) => {
            return res.criteresRepriseProduit.map((item) => {
                return {
                    id: item.id,
                    label: item.libelle,
                    reponses: item.reponses.map((reponse) => ({
                        description: reponse.description,
                        id: reponse.id,
                        label: reponse.libelle,
                    })),
                };
            });
        });
};

export const getPartnerProductTradeInQuote = async (
    productId: string,
    criteria: TradeInCriteriaResponsesType['items'],
    abortController?: AbortController,
): Promise<TradeInQuoteType> => {
    return apiHttpService
        .post<RecommerceQuoteType>(
            `${appConfig.b2r.url}/produits-partenaires/${productId}/devis`,
            {
                criteresReprise: criteria,
            },
            abortController
                ? {
                      controller: abortController,
                  }
                : undefined,
        )
        .then((res) => {
            return {
                id: res.id,
                delivery: res.livraison.map((livraison) => ({
                    deliveryMode: livraison.modeLivraison,
                    insuranceAmount: livraison.montantAssurance,
                    deliveryAmount: livraison.montantLivraison,
                })),
                estimatedRecoveryAmount: res.montantEstimeReprise,
            };
        });
};
